import { DEFAULT_STATE } from './filters';
import type { AppState, EntryType, SortKey } from './types';

const TYPES: EntryType[] = ['all', 'tool', 'web', 'app', 'game', 'product'];
const SORTS: SortKey[] = ['new', 'trending', 'popular', 'az'];

/** Serialize state to a query string, omitting defaults. Empty state → ''. */
export function stateToParams(state: AppState): string {
  const p = new URLSearchParams();
  if (state.q.trim()) p.set('q', state.q.trim());
  if (state.categories.length) p.set('cat', state.categories.join(','));
  if (state.tags.length) p.set('tag', state.tags.join(','));
  if (state.type !== DEFAULT_STATE.type) p.set('type', state.type);
  if (state.sort !== DEFAULT_STATE.sort) p.set('sort', state.sort);
  if (state.country) p.set('country', state.country);
  const s = p.toString();
  return s ? `?${s}` : '';
}

/** Parse a query string (with or without leading '?') into a validated state. */
export function paramsToState(search: string): AppState {
  const p = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const type = p.get('type') as EntryType | null;
  const sort = p.get('sort') as SortKey | null;
  const country = p.get('country') ?? '';
  return {
    q: p.get('q') ?? '',
    categories: (p.get('cat') ?? '').split(',').map((c) => c.trim()).filter(Boolean),
    tags: (p.get('tag') ?? '').split(',').map((t) => t.trim()).filter(Boolean),
    type: type && TYPES.includes(type) ? type : DEFAULT_STATE.type,
    sort: sort && SORTS.includes(sort) ? sort : DEFAULT_STATE.sort,
    country: /^[A-Za-z]{2}$/.test(country) ? country.toUpperCase() : null,
  };
}
